import React, { Component } from 'react'
import './App.css'
import './Event.css'
import { Link, withRouter } from 'react-router-dom'
import Axios from 'axios'
import TopBarProgress from 'react-topbar-progress-indicator'
import Cookies from 'universal-cookie'
import { v4 as uuidv4 } from 'uuid'
import md5 from 'md5'
import Header from './layouts/Header'
import { API_URL } from './config'

const uuid6 = uuidv4().toUpperCase()

const cookies = new Cookies()
if (!cookies.get('clientid')) {
  cookies.set('clientid', uuidv4().toUpperCase())
}

/* ---------- small helpers ---------- */

const todayString = () => {
  const d = new Date()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${m}-${day}`
}

const prettyDate = (value) => {
  if (!value) return ''
  const d = new Date(`${value}T00:00:00`)
  if (isNaN(d.getTime())) return value
  return d.toLocaleDateString('en-ZA', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

const money = (n) => `R${Number(n).toFixed(2)}`

const Icon = ({ name, size = 20 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }
  switch (name) {
    case 'calendar':
      return (
        <svg {...common}>
          <rect x="3" y="4" width="18" height="18" rx="3" />
          <path d="M16 2v4M8 2v4M3 10h18" />
        </svg>
      )
    case 'clock':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      )
    case 'pin':
      return (
        <svg {...common}>
          <path d="M12 22s7-6.2 7-12a7 7 0 1 0-14 0c0 5.8 7 12 7 12z" />
          <circle cx="12" cy="10" r="2.5" />
        </svg>
      )
    case 'back':
      return (
        <svg {...common}>
          <path d="M15 18l-6-6 6-6" />
        </svg>
      )
    case 'share':
      return (
        <svg {...common}>
          <circle cx="18" cy="5" r="3" />
          <circle cx="6" cy="12" r="3" />
          <circle cx="18" cy="19" r="3" />
          <path d="M8.6 13.5l6.8 4M15.4 6.5l-6.8 4" />
        </svg>
      )
    case 'arrow':
      return (
        <svg {...common}>
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      )
    case 'ticket':
      return (
        <svg {...common}>
          <path d="M3 9a2 2 0 0 0 0 6v3a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-3a2 2 0 0 1 0-6V6a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1z" />
          <path d="M14 5v14" strokeDasharray="2 3" />
        </svg>
      )
    default:
      return null
  }
}

class Event extends Component {
  constructor(props) {
    super(props)
    this.eventId = props.match.params.eventId
    this.ticketsRef = React.createRef()
    this.copyTimer = null
  }

  state = {
    error: null,
    detailsError: null,
    products: [],
    tickets: [],
    likeLabel: '',
    liked: '',
    likes: 0,
    loadBarProgress: false,
    fetchingTickets: true,
    description: '',
    venue: '',
    eventName: '',
    eventDate: '',
    startTime: '',
    endTime: '',
    poster: '',
    businessId: 0,
    eventId: 0,
    campaignStatus: 'stop',
    copied: false,
  }

  componentDidMount() {
    const eventId = this.eventId

    const query = new URLSearchParams(this.props.location.search)

    const customerid = query.get('customerid')
    const clientid = cookies.get('clientid')

    // get user operating system
    var userAgent = window.navigator.userAgent,
      platform = window.navigator.platform,
      macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
      windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
      iosPlatforms = ['iPhone', 'iPad', 'iPod'],
      os = null

    if (macosPlatforms.indexOf(platform) !== -1) {
      os = platform
    } else if (iosPlatforms.indexOf(platform) !== -1) {
      os = platform
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
      os = 'Windows'
    } else if (/Android/.test(userAgent)) {
      os = 'Android'
    }

    // get user agent
    let browser = ''
    if (window.navigator.userAgent.indexOf('Edg/') > -1) {
      browser = 'Edge'
    } else if (window.navigator.userAgent.indexOf('Edge/') > -1) {
      browser = 'Edge'
    } else if (window.navigator.userAgent.indexOf('MSIE') > -1) {
      browser = 'Internet Explorer'
    } else if (
      window.navigator.userAgent.indexOf('Safari') > -1 &&
      window.navigator.userAgent.indexOf('Chrome') == -1
    ) {
      browser = 'Safari'
    } else if (window.navigator.userAgent.indexOf('Firefox') > -1) {
      browser = 'Firefox'
    } else if (window.navigator.userAgent.indexOf('Chrome') > -1) {
      browser = 'Chrome'
    } else if (window.navigator.userAgent.indexOf('Linux') > -1) {
      browser = 'Linux'
    }

    const device = os

    // get likes
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=GETNUMBEROFLIKES&eventid=${eventId}`,
      {
        withCredentials: true,
      },
    ).then((response) => {
      this.setState({ likes: response.data.likes })
    })

    // get event details
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=FETCH-EVENT-DETAILS&customerid=${customerid}&eventid=${eventId}`,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        document.title = 'Karamale | ' + response.data.eventName
        this.setState({
          description: response.data.description,
          venue: response.data.venue,
          eventName: response.data.eventName,
          eventDate: response.data.eventDate,
          startTime: response.data.startTime,
          poster: response.data.poster,
          businessId: response.data.businessId,
          endTime: response.data.endTime,
          campaignStatus: response.data.campaignStatus,
        })
      })
      .catch((err) => {
        this.setState({ detailsError: err })
      })

    // Calculate impressions
    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=INSERTIMPRESSION&eventid=${eventId}&businessid=${this.state.businessId}&clientid=${clientid}&device=${device}&browser=${browser}`,
      {
        withCredentials: true,
      },
    ).then((response) => {
      // alert(response.data.businessid);
    })

    Axios.get(`${API_URL}/apps/kscanner/webservices.php?query=TICKETS&eventid=${this.eventId}`, {
      withCredentials: true,
    })
      .then((response) => {
        this.setState({
          tickets: response.data,
          fetchingTickets: false,
        })
      })
      .catch(() => {
        this.setState({ fetchingTickets: false })
      })
  }

  componentWillUnmount() {
    clearTimeout(this.copyTimer)
  }

  share = async () => {
    const url = window.location.href
    try {
      if (navigator.share) {
        await navigator.share({ title: this.state.eventName, url })
      } else if (navigator.clipboard) {
        await navigator.clipboard.writeText(url)
        this.setState({ copied: true })
        clearTimeout(this.copyTimer)
        this.copyTimer = setTimeout(() => this.setState({ copied: false }), 2000)
      }
    } catch (e) {
      // user cancelled share
    }
  }

  scrollToTickets = () => {
    if (this.ticketsRef.current) {
      this.ticketsRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  goBack = () => this.props.history.goBack()

  /* ---------- ticket list ---------- */

  tickets = (saleOpen, fulldate) => {
    const query = new URLSearchParams(this.props.location.search)

    const accountid = query.get('accountid')
    const customerid = query.get('customerid')
    const accounttype = query.get('accounttype')
    const customername = query.get('customername')
    const email = query.get('email')
    const phone = query.get('phone')
    const previousPage = query.get('previousPage')
    const category = query.get('category')
    const campaignStatus = this.state.campaignStatus
    const posterUri = `${API_URL}/apps/kscanner/posters/${this.state.businessId}/${this.eventId}/${this.state.poster}`

    if (this.state.fetchingTickets) {
      return (
        <div className="ev-loading" aria-busy="true" aria-live="polite">
          <i />
          <i />
        </div>
      )
    }

    if (!this.state.tickets || this.state.tickets.length === 0) {
      return (
        <div className="ev-note ev-note--info">
          No tickets have been released for this event yet.
        </div>
      )
    }

    return (
      <div className="ev-tickets">
        {this.state.tickets.map((item, index) => {
          let ticket = ''
          let tierClass = ''

          if (item.ticket_cat == 'VVIP') {
            ticket = 'VVIP'
            tierClass = 'ev-tier--vvip'
          } else if (item.ticket_cat == 'VIP') {
            ticket = 'VIP'
            tierClass = 'ev-tier--vip'
          } else {
            ticket = 'General'
            tierClass = 'ev-tier--general'
          }

          const avail = parseInt(item.avail_tickets)
          const kidsAvail = parseInt(item.kids_tickets)
          const soldOut = avail <= 0 && kidsAvail <= 0
          const fewLeft =
            !soldOut && ((avail > 0 && avail <= 10) || (kidsAvail > 0 && kidsAvail <= 10))
          const isFree = Number(item.price) <= 0 && Number(item.kids_price) <= 0

          const inner = (
            <>
              <div className="ev-ticket__main">
                <div className="ev-ticket__top">
                  <span className={`ev-tier ${tierClass}`}>{ticket}</span>
                  {soldOut && <span className="ev-flag ev-flag--sold">Sold out</span>}
                  {fewLeft && <span className="ev-flag ev-flag--few">Few left</span>}
                </div>
                <div className="ev-prices">
                  {isFree && (
                    <div className="ev-price">
                      <small>Entry</small>
                      <b>Free</b>
                    </div>
                  )}
                  {Number(item.price) > 0 && (
                    <div className="ev-price">
                      <small>Adults</small>
                      <b>{money(item.price)}</b>
                    </div>
                  )}
                  {Number(item.kids_price) > 0 && (
                    <div className="ev-price">
                      <small>Kids</small>
                      <b>{money(item.kids_price)}</b>
                    </div>
                  )}
                </div>
              </div>
              <div className="ev-ticket__go">
                <span>
                  <Icon name="arrow" size={18} />
                </span>
              </div>
            </>
          )

          if (soldOut || !saleOpen) {
            return (
              <div key={item.id || index} className="ev-ticket ev-ticket--sold">
                {inner}
              </div>
            )
          }

          const params = {
            fulldate: fulldate,
            eventDate: this.state.eventDate,
            price: item.price,
            kids_price: item.kids_price,
            ticketid: item.id,
            ticketref: item.ticketref,
            command: 1,
            customerid: customerid,
            posterUri: this.state.poster,
            customername: customername,
            email: email,
            phone: phone,
            accountid: accountid,
            accounttype: accounttype,
            eventtype: category,
            province: this.state.province,
            venue: this.state.venue,
            description: this.state.description,
            businessid: this.state.businessId,
            eventid: this.eventId,
            poster: posterUri,
            eventname: this.state.eventName,
            eventday: this.state.eventDate,
            starttime: this.state.startTime,
            endtime: this.state.endTime,
            previousPage: previousPage,
            prevPage: 'event',
            campaignStatus: campaignStatus,
            category: ticket,
            sold: item.sold,
            avail_tickets: item.avail_tickets,
            kids_sold: item.kids_sold,
            kids_tickets: item.kids_tickets,
          }

          const search = Object.keys(params)
            .map((k) => `${k}=${encodeURIComponent(params[k])}`)
            .join('&')

          return (
            <Link
              key={item.id || index}
              className="ev-ticket"
              aria-label={`Buy ${ticket} tickets`}
              to={{
                pathname: '/checkout/' + this.eventId + '/' + md5(uuid6),
                search,
                state: {
                  fromHome: true,
                  fulldate: fulldate,
                  eventDate: this.state.eventDate,
                  price: item.price,
                  ticketid: item.id,
                  ticketref: item.ticketref,
                  command: 1,
                  customerid: customerid,
                  posterUri: posterUri,
                  customername: customername,
                  email: email,
                  phone: phone,
                  accountid: accountid,
                  accounttype: accounttype,
                  category: ticket,
                  venue: this.state.venue,
                  description: this.state.description,
                  businessid: this.state.businessId,
                  eventid: this.eventId,
                  poster: this.state.poster,
                  eventname: this.state.eventName,
                  eventday: this.state.eventDate,
                  starttime: this.state.startTime,
                  endtime: this.state.endTime,
                  previousPage: previousPage,
                  prevPage: 'event',
                  campaignStatus: campaignStatus,
                },
              }}
            >
              {inner}
            </Link>
          )
        })}
      </div>
    )
  }

  /* ---------- render ---------- */

  render() {
    const { loadBarProgress, detailsError } = this.state

    const fulldate = todayString()
    const eventDate = this.state.eventDate
    const saleOpen = eventDate >= fulldate
    const loadingDetails = !this.state.eventName && !detailsError
    const loggedIn = localStorage.getItem('customerid') !== null
    const running = this.state.campaignStatus == 'running'
    const posterUri = `${API_URL}/apps/kscanner/posters/${this.state.businessId}/${this.eventId}/${this.state.poster}`
    const hasPoster = !!this.state.poster

    // lowest adult price among tickets still on sale (for the mobile bar)
    const prices = (this.state.tickets || [])
      .filter((t) => !(parseInt(t.avail_tickets) <= 0 && parseInt(t.kids_tickets) <= 0))
      .map((t) => Number(t.price))
      .filter((p) => p > 0)
    const fromPrice = prices.length ? Math.min(...prices) : null

    if (detailsError) {
      return (
        <div className="ev-page">
          <Header />
          <div className="ev-error">
            <h2>We couldn’t load this event</h2>
            <p>Check your connection and try again.</p>
            <button className="ev-btn ev-btn--primary" onClick={() => window.location.reload()}>
              Try again
            </button>
          </div>
        </div>
      )
    }

    let statusClass = ''
    let statusText = 'Tickets on sale'
    if (!saleOpen) {
      statusClass = 'ev-status--ended'
      statusText = 'Event ended'
    } else if (!running) {
      statusClass = 'ev-status--paused'
      statusText = 'Not on sale right now'
    }

    return (
      <div className="ev-page">
        <Header />
        {loadBarProgress && <TopBarProgress />}

        {/* ---------- hero ---------- */}
        <section className="ev-hero">
          {hasPoster && (
            <div className="ev-hero__bg" style={{ backgroundImage: `url("${posterUri}")` }} />
          )}
          <div className="ev-hero__shade" />
          <div className="ev-wrap ev-hero__inner">
            <button type="button" className="ev-back" onClick={this.goBack}>
              <Icon name="back" size={18} /> Back
            </button>

            {loadingDetails ? (
              <div className="ev-hero__grid">
                <div className="sk sk--poster" />
                <div className="ev-hero__info">
                  <span className="sk sk--line" style={{ width: 140 }} />
                  <span className="sk sk--line" style={{ width: '80%', height: 48 }} />
                  <span className="sk sk--line" style={{ width: '60%', height: 64 }} />
                </div>
              </div>
            ) : (
              <div className="ev-hero__grid">
                <div className="ev-poster">
                  {hasPoster ? (
                    <img src={posterUri} alt={this.state.eventName} />
                  ) : (
                    <div className="ev-poster__empty">
                      <Icon name="ticket" size={48} />
                    </div>
                  )}
                </div>

                <div className="ev-hero__info">
                  <span className={`ev-status ${statusClass}`}>
                    <i /> {statusText}
                  </span>
                  <h1 className="ev-title">{this.state.eventName}</h1>

                  <ul className="ev-facts">
                    <li className="ev-fact">
                      <span className="ev-fact__ic">
                        <Icon name="calendar" size={18} />
                      </span>
                      <span className="ev-fact__tx">
                        <small>Date</small>
                        <b>{prettyDate(this.state.eventDate)}</b>
                      </span>
                    </li>
                    <li className="ev-fact">
                      <span className="ev-fact__ic">
                        <Icon name="clock" size={18} />
                      </span>
                      <span className="ev-fact__tx">
                        <small>Time</small>
                        <b>
                          {this.state.startTime}
                          {this.state.endTime ? ` – ${this.state.endTime}` : ''}
                        </b>
                      </span>
                    </li>
                    <li className="ev-fact">
                      <span className="ev-fact__ic">
                        <Icon name="pin" size={18} />
                      </span>
                      <span className="ev-fact__tx">
                        <small>Venue</small>
                        <b>{this.state.venue}</b>
                      </span>
                    </li>
                  </ul>

                  <div className="ev-hero__actions">
                    {saleOpen && running && (
                      <button
                        type="button"
                        className="ev-btn ev-btn--primary"
                        onClick={this.scrollToTickets}
                      >
                        <Icon name="ticket" size={18} /> Get tickets
                      </button>
                    )}
                    <button type="button" className="ev-btn ev-btn--ghost" onClick={this.share}>
                      <Icon name="share" size={18} /> {this.state.copied ? 'Link copied' : 'Share'}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>

        {/* ---------- body ---------- */}
        <main className="ev-wrap ev-body">
          <div className="ev-content">
            {this.state.description ? (
              <section className="ev-card">
                <h2 className="ev-h2">About this event</h2>
                <div
                  className="ev-prose"
                  dangerouslySetInnerHTML={{
                    __html: this.state.description,
                  }}
                />
              </section>
            ) : null}

            {this.state.venue ? (
              <section className="ev-card">
                <div className="ev-card__head">
                  <h2 className="ev-h2">Venue</h2>
                  <a
                    className="ev-btn ev-btn--outline ev-btn--sm"
                    href={
                      'https://www.google.com/maps/search/?api=1&query=' +
                      encodeURIComponent(this.state.venue)
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon name="pin" size={16} /> Open in Maps
                  </a>
                </div>
                <p className="ev-venue">{this.state.venue}</p>
                <div className="ev-map">
                  <iframe
                    title="Event location"
                    loading="lazy"
                    src={
                      'https://maps.google.com/maps?t=&z=13&ie=UTF8&iwloc=&output=embed&q=' +
                      encodeURIComponent(this.state.venue)
                    }
                  ></iframe>
                </div>
              </section>
            ) : null}
          </div>

          {/* ---------- tickets ---------- */}
          <aside className="ev-panel" id="tickets" ref={this.ticketsRef}>
            <div className="ev-panel__card">
              <div className="ev-panel__head">
                <h2>Tickets</h2>
                {saleOpen && running && <span>Select a ticket to continue</span>}
              </div>

              {loadingDetails ? (
                <div className="ev-loading" aria-busy="true">
                  <i />
                  <i />
                </div>
              ) : !saleOpen ? (
                <div className="ev-note ev-note--warn">
                  This event has ended. Ticket sales are closed.
                </div>
              ) : !running ? (
                <div className="ev-note ev-note--info">
                  This event isn’t active right now. Please check back later.
                </div>
              ) : loggedIn ? (
                this.tickets(saleOpen, fulldate)
              ) : (
                <div className="ev-auth">
                  <p>Log in or register to buy tickets.</p>
                  <div className="ev-auth__row">
                    <Link to="/login" className="ev-btn ev-btn--primary">
                      Log in
                    </Link>
                    <Link to="/customer-registration" className="ev-btn ev-btn--outline">
                      Register
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </aside>
        </main>

        {/* ---------- mobile action bar ---------- */}
        {saleOpen && running && !loadingDetails && (
          <div className="ev-bar">
            <div className="ev-bar__price">
              {fromPrice !== null ? (
                <>
                  <small>From</small>
                  <b>{money(fromPrice)}</b>
                </>
              ) : (
                <b>Tickets</b>
              )}
            </div>
            <button type="button" className="ev-btn ev-btn--primary" onClick={this.scrollToTickets}>
              Get tickets
            </button>
          </div>
        )}
      </div>
    )
  }
}

export default withRouter(Event)
